export default "__VITE_ASSET__e5978553__"